import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-organization-admin',
  templateUrl: './organization-admin.component.html',
  styleUrls: ['./organization-admin.component.css']
})
export class OrganizationAdminComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
